import { render, staticRenderFns } from "./ModalCustomerAboutToExpire.vue?vue&type=template&id=510367b2&"
import script from "./ModalCustomerAboutToExpire.vue?vue&type=script&lang=js&"
export * from "./ModalCustomerAboutToExpire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports